import { useQuery } from "@tanstack/react-query"

import { bffApi } from "@/queries/apiClient"
import formatStartDate from "@/queries/helpers/formatStartDate"
import queryKeys from "@/queries/queryKeys"

import { DateRangeAdvisory } from "../models/DateRangeAdvisory"

export interface UseDateRangeAdvisoryOptions {
  resortExternalId: number
  date: Date
}

const useDateRangeAdvisoryQuery = (options: UseDateRangeAdvisoryOptions) => {
  const { resortExternalId, date } = options
  const formattedDate = formatStartDate(date)

  return useQuery<DateRangeAdvisory[]>({
    queryKey: queryKeys.dateRangeAdvisory(resortExternalId, formattedDate),
    queryFn: async () => {
      const res = await bffApi.get<DateRangeAdvisory[]>(
        "/date-range-advisory",
        {
          params: {
            externalResortId: resortExternalId,
            date: formattedDate,
          },
        }
      )

      return Array.isArray(res.data) ? res.data : []
    },
  })
}

export default useDateRangeAdvisoryQuery
